/** Opcion de react-select para sitios: muestra nombre, RFC y razon social. */
export const OpcionSitiosSelect = (props: any) => {
  const { innerProps, innerRef, isSelected, isFocused } = props
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className='p-3 custom-select'
      style={{
        backgroundColor: isSelected ? '#ffd5c4' : isFocused ? '#ffe7e2' : '#f5f8fa',
      }}>
      <h4>
        {props?.data.etiqueta} <span className='text-muted fw-light'>{props?.data.rfc}</span>
      </h4>
      <div className='text-nowrap mt-2' style={{}}>
        {props?.data.descRazonSocial}
      </div>
    </div>
  )
}
/** Opcion de react-select para usuarios: muestra nombre completo y correo. */
export const OpcionUsuarioSelect = (props: any) => {
  const { innerProps, innerRef, isSelected, isFocused } = props
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className='p-3 custom-select'
      style={{
        backgroundColor: isSelected ? '#ffd5c4' : isFocused ? '#ffe7e2' : '#f5f8fa',
      }}>
      <h4 className='d-flex justify-content-between ml-3'>
        {props?.data.etiqueta}
        <span className='text-muted fs-6'>{props?.data.correo}</span>
      </h4>
      <div className='d-flex text-nowrap mt-2 justify-content-end' style={{}}>
        {props?.data.descPosicion}
      </div>
    </div>
  )
}
/** Opcion de react-select para autorizaciones: muestra numero y etiqueta. */
export const OpcionesSelectAutorizaciones = (props: any) => {
  const { innerProps, innerRef, isSelected, isFocused } = props
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className='p-3 custom-select'
      style={{
        backgroundColor: isSelected ? '#ffd5c4' : isFocused ? '#ffe7e2' : '#f5f8fa',
      }}>
      <h4>{props?.data.etiqueta}</h4>
      <div className='text-nowrap mt-2' style={{}}>
        {props?.data.numero}
      </div>
    </div>
  )
}

/** Opcion de react-select para contacto de sitio: muestra nombre y idContacto. */
export const OpcionSitiosContacto = (props: any) => {
  const { innerProps, innerRef, isSelected, isFocused } = props
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className='p-3 custom-select'
      style={{
        backgroundColor: isSelected ? '#ffd5c4' : isFocused ? '#ffe7e2' : '#f5f8fa',
      }}>
      <h4>
        {props?.data.etiqueta} <span className='text-muted fw-light'>{props?.data.nombre}</span>
      </h4>
      <div className='text-nowrap mt-2' style={{}}>
        {props?.data.idContacto}
      </div>
    </div>
  )
}

/** Opcion generica de react-select para filtros: muestra etiqueta + extra + descripcion. */
export const OpcionFiltros = (props: any) => {
  const { innerProps, innerRef, isSelected, isFocused } = props
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className='p-3 custom-select'
      style={{
        backgroundColor: isSelected ? '#ffd5c4' : isFocused ? '#ffe7e2' : '#f5f8fa',
      }}>
      <h4>
        {props?.data.etiqueta}
        <span className='text-muted fw-light'>{props?.data.extra}</span>
      </h4>
      <div className='text-nowrap mt-2' style={{}}>
        {props?.data.descripcion}
      </div>
    </div>
  )
}
